export default __webpack_public_path__ + "static/media/help7.972dbdcf.svg";